import { TranslatePipe } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  selector: "cert-header",
  templateUrl: "cert-header.html",
  styleUrl: "cert-header.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe],
})
export class CertHeader {}
